(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("queue", [], factory);
	else if(typeof exports === 'object')
		exports["queue"] = factory();
	else
		root["queue"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 